import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function LiberationSection() {
  return <section className="py-32 relative flex items-center justify-center text-center overflow-hidden" data-id="element-135">
      {/* Abstract dark background to represent deep space/breaking free */}
      <div className="absolute inset-0 bg-navy-950" data-id="element-136">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(212,175,55,0.08)_0%,transparent_60%)]" data-id="element-137"></div>
      </div>

      <div className="max-w-4xl mx-auto px-6 md:px-12 relative z-10" data-id="element-138">
        <FadeIn data-id="element-139">
          <h2 className="text-5xl md:text-6xl lg:text-7xl font-bold mb-8 leading-[1.1]" data-id="element-140">
            Tu deuda es su negocio. <br data-id="element-141" />
            <span className="text-gradient-gold" data-id="element-142">
              Tu libertad es tu victoria.
            </span>
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-143">
          <p className="text-xl md:text-2xl text-gray-300 font-light max-w-3xl mx-auto leading-relaxed" data-id="element-144">
            El sistema te quiere endeudado y asustado. Pero cuando dominas tu
            crédito y empiezas a invertir, las cadenas se rompen.
            <br data-id="element-145" />
            <br data-id="element-146" />
            <span className="text-white font-medium" data-id="element-147">
              Este no es un libro de finanzas, es un manifiesto de liberación
              para el latino en Estados Unidos.
            </span>
          </p>
        </FadeIn>
      </div>
    </section>;
}